import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1f9f3e65"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-ellipsis-line-one" }
const _hoisted_2 = ["innerHTML"]

import { ref, reactive, watch, onMounted, nextTick, PropType, computed, readonly } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import { FormActionType, FormSize, FormSizeType, FormType, ActionType } from '@/components/cmForm/types'
import { TableOpt, TableActOpt } from '@/components/cmTable/types'
import { PermissionFe, ServicePermissionService, getAreaByTerminalType } from '@/services/service-permission.service'
import { PolicyCommonService } from '@/views/dashboard/policy/policy-common.service'
import { SensitiveService, GetSensitiveWordsSensitiveFilesResponseDataRow, ResponseDataSensitiveWordsFileView, SensitiveWordsFileListResponseData, SensitiveWordsFileListRequestParams } from '../service'
import { TerminalType } from '@/views/dashboard/_enum/terminal-type'
import { DataTypeSensitive, DataTypeSensitiveText, ExcludeRequestParamsFileView, QueryFormFileViewType } from '../types/sensitive-file-scanning'
import { computerInfoCols } from '../../ransomware-protection/types/ransomware-incident'
import GroupTreeSelector from '@/views/dashboard/_components/group-tree-selector/group-tree-selector.vue'
import Keywords from '../components/Keywords.vue'
import SensitiveFileDetail from '../components/sensitive-file-detail.vue'
import ScanReport from '../components/ScanReport.vue'
import ScanningConfig from '../components/scanning-config.vue'
import DataHistory from '../components/DataHistory.vue'
import { formatTimeStamp } from '@/utils/time'
import { bytesToSize, highLightKeywords } from '@/utils/tool'
import { BrandConfig, useBrandCustomStore } from '@/services/brand-custom.service'
import { GetSensitiveWordsResultsRequestParamsDataRow } from '../service'
import { TableViewMode, TableViewModeType } from '@/views/dashboard/_enum/table-view-mode'
import { listCol } from '@/utils/list-columns-i18n'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'sensitive-file-list-section',
  props: {
    viewMode: { default: TableViewMode.preview },
    hasPermission: { type: Boolean, default: true }
  },
  emits: ["viewAll", "fileViewTotal"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const injector = useReflectiveInjector([PolicyCommonService, SensitiveService])
const servicePermissionService = injector.get(ServicePermissionService)
const hasPermission = props.hasPermission || servicePermissionService.getHasPermission(PermissionFe.dlp_control)
const sensitiveService = injector.get(SensitiveService)
const brandConfig = useBrandCustomStore().brandConfig as BrandConfig

const getSensitiveWordsListApi = sensitiveService.getSensitiveWordsList.bind(sensitiveService)
const getSensitiveWordsSensitiveFilesApi = sensitiveService.getSensitiveWordsSensitiveFiles.bind(sensitiveService)
const getSensitiveWordsResultsApi = sensitiveService.getSensitiveWordsResults.bind(sensitiveService)
const getSensitiveWordsScanApi = sensitiveService.getSensitiveWordsScan.bind(sensitiveService)
const getSensitiveWordsFileListApi = sensitiveService.getSensitiveWordsFileList.bind(sensitiveService)
const getSensitiveWordsFileViewApi = sensitiveService.getSensitiveWordsFileView.bind(sensitiveService)
const getSensitiveWordsOutgoingRecordApi = sensitiveService.getSensitiveWordsOutgoingRecord.bind(sensitiveService)
const getSensitiveWordsSensitiveFileInfoApi = sensitiveService.getSensitiveWordsSensitiveFileInfo.bind(sensitiveService)
const getSensitiveWordsFileViewCountApi = sensitiveService.getSensitiveWordsFileViewCount.bind(sensitiveService)

const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const currentIndex = ref()
const groupBySelected = ref(false)
const id = ref()
const dataVisible = ref(false)
const visibleDetail = ref(false)
const visibleScanReport = ref(false)
const visibleScanningConfig = ref(false)
const formSize: FormSizeType = FormSize.Small
const queryFormDisabled = ref(!hasPermission)
const fileForm = ref({
  keyword: '全部',
  category: '全部'
})
const total_file_count = ref(0)
const sensitiveWordsFileList = ref([] as SensitiveWordsFileListResponseData[])
const sensitiveWordsFileListAll = ref([] as SensitiveWordsFileListResponseData[])
const detailInfo = ref({} as GetSensitiveWordsResultsRequestParamsDataRow)

const queryParams = reactive<QueryFormFileViewType & { page?: number; limit?: number; key_word?: string }>({
  system_types: [1, 3],
  page: 1,
  limit: props.viewMode === TableViewMode.preview ? 10 : 20,
  key_word: ''
})

// 监听 viewMode 变化，更新 limit
watch(() => props.viewMode, (newMode) => {
  queryParams.limit = newMode === TableViewMode.preview ? 10 : 20
  queryParams.page = 1
  if (tableRef.value) {
    void refreshList()
  }
})
function onViewAll() {
  if (!hasPermission) return
  emit('viewAll')
}

const { t, locale } = useI18n()

/**
 * 栏外「命中敏感词」为单选，v-model 可能是 string；接口与其它逻辑统一为 string[]。
 */
function normalizeKeywordsToStringArray (raw: unknown): string[] | undefined {
  if (raw == null || raw === '') {
    return undefined
  }
  if (Array.isArray(raw)) {
    const out = raw
      .flat(Infinity)
      .filter((k): k is string => typeof k === 'string' && k.trim().length > 0)
      .map(k => k.trim())
    return out.length ? [...new Set(out)] : undefined
  }
  if (typeof raw === 'string' && raw.trim()) {
    return [raw.trim()]
  }
  return undefined
}

function syncQueryParamsKeywordsForApi () {
  const arr = normalizeKeywordsToStringArray(queryParams.keywords)
  if (!arr?.length) {
    delete queryParams.keywords
  } else {
    queryParams.keywords = arr
  }
}

/** 栏外「命中敏感词」下拉选项（随 getSensitiveWordsFileList 的 keywords 入参刷新） */
const keywordSelectDictData = ref<{ keyword: string; label: string }[]>([])

async function loadSensitiveWordsKeywordOptions () {
  const params: SensitiveWordsFileListRequestParams = {}
  if (Array.isArray(queryParams.keywords) && queryParams.keywords.length > 0) {
    params.keywords = queryParams.keywords.filter((k): k is string => typeof k === 'string' && k.length > 0)
  }
  const result = await getSensitiveWordsFileListApi(params)
  const data = result.data ?? []
  sensitiveWordsFileList.value = data
  sensitiveWordsFileListAll.value = data
  formItemKeyword.value.dictData = [{ keyword: '全部', name: '', label: t('sensitiveFileScanning.all') }, ...data.map((item: any) => ({ ...item, label: item.keyword }))]
  keywordSelectDictData.value = data
    .map(item => ({ keyword: (item.keyword ?? '').trim(), label: (item.keyword ?? '').trim() }))
    .filter(item => item.keyword)
}

async function onKeywordsFilterChange () {
  if (!hasPermission) return
  syncQueryParamsKeywordsForApi()
  queryParams.page = 1
  await loadSensitiveWordsKeywordOptions()
  await refreshList()
  await getSensitiveWordsFileViewCount(queryParams)
}

const filterFormColumns = computed(() => {
  void locale.value
  return [
    {
      prop: 'group_id',
      colOpt: { style: 'width: 160px;flex: 0 0 auto' },
      slot: true,
      hidden: () => false,
      hiddenAllLabel: true,
      outSearchFiledFlag: true,
      type: FormType.Select,
      events: {
        change: handleQuery,
      },
    },
    {
      prop: 'keywords',
      label: t('sensitiveFileScanning.hitSensitiveWord'),
      colOpt: { style: 'width: 240px;flex: 0 0 auto' },
      outSearchFiledFlag: true,
      type: FormType.Select,
      selectOpt: {
        clearable: true,
        filterable: true,
        collapseTags: true,
        size: FormSize.Small,
      },
      props: { label: 'label', value: 'keyword' },
      dictData: keywordSelectDictData.value,
      hiddenAllLabel: true,
      events: {
        change: onKeywordsFilterChange,
      },
    },
  ]
})

const formItemFile = ref({
  prop: 'category',
  colOpt: { span: 24 },
  disabled: () => !hasPermission,
  label: t('sensitiveFileScanning.sensitiveWordType'),
  type: FormType.Select,
  selectOpt: {
    filterable: true,
    size: FormSize.Small,
  },
  props: { label: 'label', value: 'name' },
  events: {
    change: (v) => {
      sensitiveWordsFileList.value = v === '全部' ? sensitiveWordsFileListAll.value : sensitiveWordsFileListAll.value.filter(item => item.name === v)
      formItemKeyword.value.dictData = [{ keyword: '全部', name: '', label: t('sensitiveFileScanning.all') }, ...sensitiveWordsFileList.value.map((item: any) => ({ ...item, label: item.keyword }))]
      currentIndex.value = ''
      fileForm.value.keyword = '全部'
      queryParams.keywords = sensitiveWordsFileList.value.map(item => item.keyword).filter(Boolean) as string[]
      void loadSensitiveWordsKeywordOptions()
      void refreshList()
      getSensitiveWordsFileViewCount(queryParams)
      window.location.hash = ''
    },
  },
  dictData: [],
})

const formItemKeyword = ref({
  prop: 'keyword',
  colOpt: { span: 24 },
  label: t('sensitiveFileScanning.hitSensitiveWord'),
  disabled: () => !hasPermission,
  type: FormType.Select,
  selectOpt: {
    filterable: true,
    size: FormSize.Small,
  },
  props: { label: 'label', value: 'keyword' },
  events: {
    change: (v) => {
      if (v === '全部') {
        currentIndex.value = ''
        queryParams.keywords = sensitiveWordsFileList.value.map(item => item.keyword).filter(Boolean) as string[]
      } else {
        currentIndex.value = sensitiveWordsFileList.value.findIndex(i => i.keyword === v)
        queryParams.keywords = [v]
      }
      void loadSensitiveWordsKeywordOptions()
      void refreshList()
      window.location.hash = v
    },
  },
  dictData: [],
})

const tableActOpt = reactive({
  columnOpt: { label: t('sensitiveFileScanning.operationRecord'), minWidth: 100, align: 'left', fixed: 'right' },
  actionButtons: (row: any) => [
    {
      name: listCol(t, 'detail'),
      disabled: () => !hasPermission,
      type: ActionType.Detail,
      opt: { size: FormSize.Small, text: true, type: 'text' },
      events: {
        click: () => {
          window.open('/dashboard/data-discovery/' + row.node_id, '_blank')
        }
      }
    },
  ],
})

const tableOpt = computed<TableOpt>(() => ({
  path: 'data',
  height: (props.viewMode === TableViewMode.full || IS_JP_ONLY_BUILD) ? '100%' : undefined,
  bodyStyle: props.viewMode === TableViewMode.full ? 'padding:10px 16px' : undefined,
  showActionBar: false,
  showForm: false,
  showRightToolbar: false,
  rowKey: 'node_id',
  selection: false,
  showTip: false,
  usePagination: false,
  disableScrollLoad: props.viewMode === TableViewMode.preview,
  scrollLoadThreshold: 10,
  scrollLoadDelay: 100,
  columns: [
    { label: listCol(t, 'fileName'), prop: 'name',  showOverflow: true, 'min-width':140 },
    { label: t('sensitiveFileScanning.hitSensitiveWord'), prop: 'keywords', 'min-width': 220 },
    { label: t('sensitiveFileScanning.lastModifyTime'), prop: 'update_time', 'min-width': 150, formatter: (_row, value) => formatTimeStamp(value, 'YYYY-MM-DD HH:mm') },
    { label: t('sensitiveFileScanning.filePath'), prop: 'path', 'min-width': 400 },
    { label: listCol(t, 'fileSize'), prop: 'size', 'min-width': 140, formatter: (_row, value) => bytesToSize(value) },
    {
      label: t('sensitiveFileScanning.outboundRecord'),
      prop: 'send_times',
      'min-width': 140,
      hidden: () => IS_JP_ONLY_BUILD,
      fixed: 'right',
      // 仅在用户点击排序时触发服务端排序，避免首屏本地排序打乱 API 返回顺序
      columnOpt: { sortable: 'custom' }
    },
    ...computerInfoCols(true, true, t),
  ],
}))

async function updateGroupId(groupId: number) {
  if (!hasPermission) return
  queryParams.group_id = groupId.toString()
  queryParams.page = 1
  await refreshList()
}

async function handleSearch(value: string) {
  queryParams.key_word = value
  await refreshList()
}

async function handleQuery(form: any) {
  Object.assign(queryParams, form)
  syncQueryParamsKeywordsForApi()
  await loadSensitiveWordsKeywordOptions()
  await refreshList()
}

async function handleReset () {
  Object.assign(queryParams, { system_types: [1, 3], page: 1, limit: props.viewMode === TableViewMode.preview ? 10 : 20, key_word: '' })
  delete queryParams.keywords
  await loadSensitiveWordsKeywordOptions()
  await refreshList()
}

function searchAll() {
  currentIndex.value = ''
  fileForm.value.keyword = '全部'
  queryParams.keywords = sensitiveWordsFileList.value.map(item => item.keyword).filter(Boolean) as string[]
  void loadSensitiveWordsKeywordOptions()
  void refreshList()
}

function handleSearchFileList(k, i) {
  if (k === currentIndex.value) return
  currentIndex.value = k
  fileForm.value.keyword = i.keyword
  queryParams.keywords = [i.keyword].filter(Boolean) as string[]
  void loadSensitiveWordsKeywordOptions()
  void refreshList()
}

function handleAction({ type }: { type: any }) {
  // Handle actions
}

async function getSensitiveWordsList() {
  const result = await getSensitiveWordsListApi({ limit: 999, page: 1 })
  for (let item of result.data) {
    item.name = item.data_type !== DataTypeSensitive.Customize ? t(DataTypeSensitiveText[item.data_type]) : item.name
  }
  formItemFile.value.dictData = [{ name: '全部', label: t('sensitiveFileScanning.all') }, ...result.data.map((item: any) => ({ ...item, label: item.name }))]
}

async function getSensitiveWordsFileViewCount(queryForm?: Partial<ResponseDataSensitiveWordsFileView>) {
  const result = await getSensitiveWordsFileViewCountApi(queryForm)
  total_file_count.value = result.total_file_count || 0
}

/** 供父页（如日文专版统计卡）打开敏感词配置抽屉 */
function openScanningConfig() {
  if (!hasPermission) return
  visibleScanningConfig.value = true
}

watch(
  total_file_count,
  (n) => {
    emit('fileViewTotal', n)
  },
  { immediate: true },
)

onMounted(async () => {
  if (!hasPermission) return
  await nextTick()
  getSensitiveWordsList()
  await loadSensitiveWordsKeywordOptions()
  await getSensitiveWordsFileViewCount(queryParams)
  void refreshList()
})

__expose({
  tableRef,
  /** 当前筛选条件下敏感文件总数（与列表同源） */
  totalFileCount: readonly(total_file_count),
  getList: () => void refreshList(),
  openScanningConfig,
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CmTable, {
      ref_key: "tableRef",
      ref: tableRef,
      tableOpt: tableOpt.value,
      tableActOpt: tableActOpt,
      firstLoading: false,
      "has-permission": _unref(hasPermission),
      api: _unref(getSensitiveWordsFileViewApi),
      modelValue: queryParams,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryParams) = $event)),
      pageOption: {
      style: 'padding-bottom: 16px',
      pageNumName: 'page',
      pageSizeName: 'limit',
    },
      menuLeftColOpt: props.viewMode === _unref(TableViewMode).full ? { span: 8 } : undefined,
      menuRightColOpt: props.viewMode === _unref(TableViewMode).full ? { span: 16 } : undefined,
      onHandleAction: handleAction
    }, {
      header: _withCtx(() => [
        _createVNode(SearchFilterBar, {
          modelValue: queryParams,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams) = $event)),
          "form-columns": filterFormColumns.value,
          disabled: !_unref(hasPermission),
          "show-search": true,
          "search-placeholder": props.viewMode === _unref(TableViewMode).full ? undefined : _ctx.$t('sensitiveFileScanning.searchPlaceholder'),
          "popover-threshold": 2,
          onSearch: handleSearch,
          onQuery: handleQuery,
          onReset: handleReset
        }, {
          group_id: _withCtx(() => [
            _createVNode(GroupTreeSelector, {
              "terminal-type": [_unref(TerminalType).windows, _unref(TerminalType).windowsServer],
              onSelected: updateGroupId
            }, null, 8, ["terminal-type"])
          ]),
          actions: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (visibleScanningConfig.value = true)),
              disabled: !_unref(hasPermission)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.sensitiveWordConfig')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              size: "small",
              plain: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (visibleScanReport.value = true)),
              disabled: !_unref(hasPermission)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.terminalScan')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              type: "primary",
              plain: "",
              size: "small",
              disabled: !_unref(hasPermission),
              onClick: onViewAll
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('commonPage.viewAll')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["modelValue", "form-columns", "disabled", "search-placeholder"])
      ]),
      send_times: _withCtx((slotProps) => [
        _createVNode(_component_el_link, {
          type: (slotProps as any).value ? 'primary' : 'default',
          underline: false,
          onClick: _withModifiers(() => { dataVisible.value = !!(slotProps as any).value; id.value = (slotProps as any).row.node_id }, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString((slotProps as any).value), 1)
          ]),
          _: 2
        }, 1032, ["type", "onClick"])
      ]),
      keywords: _withCtx((slotProps) => [
        _createVNode(Keywords, {
          "max-count": 3,
          keywords: (slotProps as any).value
        }, null, 8, ["keywords"])
      ]),
      path: _withCtx((slotProps) => [
        _createVNode(_component_el_tooltip, {
          class: "box-item",
          effect: "dark",
          content: (slotProps as any).value || '',
          placement: "top-start",
          disabled: ((slotProps as any).value || '').length <= 44
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(((slotProps as any).value || '').length > 44 ? (((slotProps as any).value || '').slice(0, 32) + '...' +
            ((slotProps as any).value || '').slice(-12)) : ((slotProps as any).value || '--')), 1)
          ]),
          _: 2
        }, 1032, ["content", "disabled"])
      ]),
      name: _withCtx((slotProps) => [
        _createElementVNode("div", {
          innerHTML: _unref(highLightKeywords)((slotProps as any).value, ((slotProps as any).row.keywords || '') + ''),
          class: "cm-ellipsis-line-one"
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["tableOpt", "tableActOpt", "has-permission", "api", "modelValue", "menuLeftColOpt", "menuRightColOpt"]),
    _createVNode(DataHistory, {
      modelValue: dataVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dataVisible).value = $event)),
      id: id.value,
      api: { recordApi: _unref(getSensitiveWordsOutgoingRecordApi), fileInfoApi: _unref(getSensitiveWordsSensitiveFileInfoApi) }
    }, null, 8, ["modelValue", "id", "api"]),
    _createVNode(SensitiveFileDetail, {
      modelValue: visibleDetail.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((visibleDetail).value = $event)),
      api: _unref(getSensitiveWordsSensitiveFilesApi),
      dataHistoryApi: { recordApi: _unref(getSensitiveWordsOutgoingRecordApi), fileInfoApi: _unref(getSensitiveWordsSensitiveFileInfoApi) },
      "has-permission": _unref(hasPermission),
      device_id: detailInfo.value.device_id,
      detailInfo: detailInfo.value
    }, null, 8, ["modelValue", "api", "dataHistoryApi", "has-permission", "device_id", "detailInfo"]),
    _createVNode(ScanReport, {
      modelValue: visibleScanReport.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((visibleScanReport).value = $event)),
      api: { getSensitiveWordsResultsApi: _unref(getSensitiveWordsResultsApi), getSensitiveWordsScanApi: _unref(getSensitiveWordsScanApi) },
      "has-permission": _unref(hasPermission)
    }, null, 8, ["modelValue", "api", "has-permission"]),
    _createVNode(ScanningConfig, {
      modelValue: visibleScanningConfig.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((visibleScanningConfig).value = $event)),
      hasPermission: _unref(hasPermission),
      detailInfo: detailInfo.value
    }, null, 8, ["modelValue", "hasPermission", "detailInfo"])
  ], 64))
}
}

})